<template>
  <div class="schedule-page">
    <!-- 返回按钮 -->
    <div class="btn-back" @click="goBack">
      <img src="../assets/bar-map/btn-back.png" alt="" />
    </div>

    <!-- 宽屏图片，居中展示 -->
    <img
      src="../assets/schedule.png"
      alt="活动日程"
      class="schedule-img"
      @click="openPreview"
    />

  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import scheduleImg from '../assets/schedule.png'

export default {
  name: 'Schedule',
  methods: {
    goBack() {
      this.back()
    },
    openPreview() {
      ImagePreview({
        images: [scheduleImg],
        showIndex: false,
        closeable: false,
        closeOnPopstate: true
      })
    }
  }
}
</script>

<style scoped lang="less">
.schedule-page {
  position: absolute;
  width: 100%;
  min-height: 100vh;
  left: 0;
  top: 0;
  background: radial-gradient(
    ellipse at center,
    #103333 0%,
    #0a1f1f 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
}

.btn-back {
  position: fixed;
  left: 26px;
  top: 24px;
  width: 121px;
  z-index: 100;
  cursor: pointer;

  img {
    display: block;
    width: 100%;
  }

  &:active {
    opacity: 0.6;
  }
}

.schedule-img {
  display: block;
  width: 100%;
  height: auto;
  cursor: zoom-in;
  animation: fadeIn 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
